import React, { useState, useRef } from 'react';
import './become-a-dealer.css';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import emailjs from '@emailjs/browser';

const BecomeADealer = () => {
    const [formData, setFormData] = useState({
        name: '',
        phoneNo: '',
        city: ''
    });

    const [phone, setPhone] = useState("");
    const [formStatus, setFormStatus] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const formRef = useRef();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const sendDealerEmail = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/send-dealer-form`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: formData.name,
                    phoneNo: phone,
                    city: formData.city
                })
            });

            const result = await response.json();

            if (result.success) {
                setFormSuccess(true);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);

                setFormData({ name: "", city: "" });
                setPhone("");
            } else {
                setFormSuccess(false);
                setFormStatus(true);
                setTimeout(() => setFormStatus(false), 5000);
            }
        } catch (err) {
            console.error(err);
            setFormSuccess(false);
            setFormStatus(true);
            setTimeout(() => setFormStatus(false), 5000);
        }
    };

    return (
        <div className="dealer-FromPage">
            <div className="dealer-form-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Find A Dealer</h1>
                    <p className="Sep-subtitle">Fill out the form to find a nearby showroom in your city.</p>
                </div>

                <form ref={formRef} onSubmit={sendDealerEmail}>
                    {/* Name Field */}
                    <div className="form-group">
                        <label htmlFor="name">Name*</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Phone Number Field */}
                    <div className="form-group">
                        <label htmlFor="phoneNo">Mobile Number*</label>
                        <PhoneInput
                            country={"in"} // ✅ India as default
                            enableSearch={true}
                            value={phone}
                            onChange={(phone) => setPhone(phone)}
                            placeholder=""
                            inputProps={{
                                name: 'phoneNo',
                                required: true
                            }}
                        />
                    </div>

                    {/* City/Area Field */}
                    <div className="form-group">
                        <label htmlFor="city">City / Area*</label>
                        <input
                            type="text"
                            id="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Success/Error Message */}
                    <div className="form-notify">
                        {formStatus && formSuccess && (
                            <p className="notify-text success">Your form has been submitted successfully!</p>
                        )}
                        {formStatus && !formSuccess && (
                            <p className="notify-text error">There was an error submitting your form. Please try again.</p>
                        )}
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="submit-btn">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default BecomeADealer;
